import { useState, type FormEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';
import { subscribeToNewsletter } from './newsletterApi';

export function FooterNewsletterForm() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');

  const subscribe = useMutation({
    mutationFn: () => subscribeToNewsletter(email),
    onSuccess: () => setEmail(''),
  });

  function handleSubmit(event: FormEvent) {
    event.preventDefault();
    subscribe.mutate();
  }

  if (subscribe.isSuccess) {
    return (
      <p className="text-sm font-medium text-manuscript-gold-400">{t('landing.footer.newsletter.success')}</p>
    );
  }

  return (
    <div>
      <form onSubmit={handleSubmit} className="flex items-center gap-2">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={t('landing.footer.newsletter.placeholder')}
          className="min-w-0 flex-1 rounded-sm border border-paper-100/20 bg-paper-100/5 px-3 py-2 text-sm text-paper-50 outline-none placeholder:text-paper-100/40 focus:border-manuscript-gold-400/60 sm:w-56"
        />
        <button
          type="submit"
          disabled={subscribe.isPending}
          aria-label={t('landing.footer.newsletter.submit')}
          className="flex shrink-0 items-center justify-center rounded-sm bg-manuscript-gold-400 px-3 py-2 text-manuscript-ink transition-colors hover:bg-manuscript-gold-300 disabled:opacity-60"
        >
          <span aria-hidden>{subscribe.isPending ? '…' : '→'}</span>
        </button>
      </form>
      {subscribe.isError && (
        <p className="mt-2 text-xs text-red-400">{t('landing.footer.newsletter.error')}</p>
      )}
    </div>
  );
}
